import { render, staticRenderFns } from "./select_paper.vue?vue&type=template&id=366ea259&scoped=true&"
import script from "./select_paper.vue?vue&type=script&lang=js&"
export * from "./select_paper.vue?vue&type=script&lang=js&"
import style0 from "./select_paper.vue?vue&type=style&index=0&id=366ea259&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366ea259",
  null
  
)

export default component.exports